import {
  Card,
  Col,
  Input,
  message,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import useSWR from 'swr';

import PageHeader from '@/components/PageHeader';
import { Instructor } from '@/types/database/instructor';

import EditInstructorButton from './components/EditInstructorButton';
import InstructorInfoBox from './components/InstructorInfoBox';
import { getInstructors, INSTRUCTORS_URL } from './helpers/api';
import { getColumns } from './helpers/ui';
import styles from './styles.module.scss';

const { Text, Title } = Typography;

const InstructorsManagement: React.FC = () => {
  const [searchName, setSearchName] = useState('');
  const [selectedInstructor, setSelectedInstructor] =
    useState<Instructor | null>(null);

  const {
    data: instructors,
    mutate,
    isLoading,
    error,
  } = useSWR(`${INSTRUCTORS_URL}?name=${searchName}`, getInstructors);

  const updateTableData = () => {
    mutate();
  };

  const columns = getColumns(updateTableData, setSelectedInstructor);

  useEffect(() => {
    if (error) {
      message.error('取得資料發生錯誤');
    }
  }, [error]);

  useEffect(() => {
    if (instructors && selectedInstructor) {
      setSelectedInstructor(
        instructors.find(
          (instructor) => instructor._id === selectedInstructor._id
        ) || null
      );
    }
  }, [instructors, selectedInstructor]);

  const dataSource = instructors?.map((instructor) => ({
    ...instructor,
    key: instructor._id,
  }));

  return (
    <div className={styles['page-container']}>
      <Space direction="vertical" className={styles['main-content']}>
        <PageHeader
          title="講師資訊管理"
          breadcrumbs={[
            {
              name: '帳號管理',
            },
            {
              name: '講師資訊管理',
            },
          ]}
        />
        <EditInstructorButton
          buttonLabel="新增講師"
          onConfirm={updateTableData}
        />
        <Space>
          <Text>講師：</Text>
          <Input
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            placeholder="例如：王小明"
          />
        </Space>
        <div className={styles['instructor-infos']}>
          <Card className={styles['instructor-infos__card']}>
            <Col>
              <Title level={5}>講師資訊</Title>
              {!isLoading && (
                <Table bordered dataSource={dataSource} columns={columns} />
              )}
              {isLoading && (
                <Row justify="center">
                  <Spin />
                </Row>
              )}
            </Col>
          </Card>
          <InstructorInfoBox
            instructor={selectedInstructor}
            closeInfoBox={() => setSelectedInstructor(null)}
          />
        </div>
      </Space>
    </div>
  );
};

export default InstructorsManagement;
